import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { theme } from "../../../assets";
import IconInstagram from "../../../assets/icons/icon-instagram";
import IconLinkedin from "../../../assets/icons/icon-linkedin";
import IconWhatsappFilled from "../../../assets/icons/icon-whatsapp-filled";
import MaintenanceMan from "../../../assets/images/maintenance-man";
import { useUser } from "../../../context";
import { redirectToWhatsApp } from "../../../utils/contact/redirect-to-whatsapp";
import * as s from "../styled-information-pages";

export const UnavailablePage = () => {
    const user = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        const isSiteOnUnavailable = process.env.REACT_APP_SERVER_UNAVAILABLE;
        if (isSiteOnUnavailable === "false") {
            if (user.isLogged) {
                navigate("/cronometro");
            } else {
                navigate("/");
            }
        }
    }, []);
    return (
        <s.Container>
            <s.content>
                <MaintenanceMan
                    height="231px"
                    width="245px"
                    className="maintenanceMan"
                />
                <div className="contentSection">
                    <s.title>Ops! O site está indisponível no momento</s.title>
                    <s.information>
                        <span>
                            Estamos trabalhando para normalizar o serviço o mais
                            rápido possível.
                        </span>
                        <span>
                            Enquanto isso, acesse nossas redes sociais ou entre
                            em contato conosco.
                        </span>
                    </s.information>
                    <s.button
                        onClick={() => {
                            navigate("/");
                        }}
                    >
                        TENTAR NOVAMENTE
                    </s.button>
                </div>
                <s.footer>
                    <IconLinkedin
                        width="36px"
                        height="36px "
                        color={theme.purple600}
                        opacity="1"
                        cursor="pointer"
                        onClick={() => {
                            window.open(
                                "https://www.linkedin.com/company/paperonapp/",
                                "_blank"
                            );
                        }}
                    />
                    <IconInstagram
                        width="36px"
                        height="36px"
                        color={theme.purple600}
                        opacity="1"
                        cursor="pointer"
                        onClick={() => {
                            window.open(
                                "https://www.instagram.com/paperon.app/",
                                "_blank"
                            );
                        }}
                    />
                    <IconWhatsappFilled
                        width="36px"
                        height="36px"
                        color={theme.purple600}
                        cursor="pointer"
                        onClick={redirectToWhatsApp}
                    />
                </s.footer>
            </s.content>
        </s.Container>
    );
};
